import React , { useEffect, useState } from 'react'; 
import storage from '../factory/StorageFactory.js';
import '../Card/card-style.css';
import FormContainer from '../components/FormContainer.jsx';
import { FaCheck, FaTimes } from 'react-icons/fa';
import config from '../appconfig/config.json';

const InvalidDirectors = (props) => {

    useEffect(() => {
 
        window.scrollTo(0,0);
        storage.clearAll();
     }, []);

    const handleOnClick = () => {
        window.location.href = config.link.GetInTouch;
    }

    const handleCancelClick = ()=> {
        window.location.href = config.link.Cancle;
    }

    return(
        <FormContainer>
            <div className="row around-xs elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{'Oops!'}</legend>
                </div>
            </div>
            <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
         
            <br/>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div style={{fontWeight:600}}>{'Who can apply'}</div>
                </div>
            </div>
            <br/>
            <div className="box">
                <FaCheck color='green'/>&nbsp;&nbsp;&nbsp;{'Business incorporated in Singapore '} 
            </div>
            <br/>
            <div className="box">
                <FaTimes color='red'/>&nbsp;&nbsp;&nbsp;{'Up to 3 Singaporeans/Singapore PRs Partners, Business Owner, Directors, Office Bearers'} 
            </div>             
            <br/> <br/>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                    <button className="btn btn-back" onClick={handleCancelClick}>{'CANCEL'}</button>
                    <button type={'submit'} className="k-button btn btn-success btn-float-right" onClick={handleOnClick}>{'GET IN TOUCH'}</button>
                </div>
            </div>  
        </FormContainer>
    )
}

export default InvalidDirectors;